module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'loading') ? _c('Loader') : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stage === 'selectDrug' && _vm.schedules.length > 0 && _vm.viewMethod === 'list'),
      expression: "stage === 'selectDrug' && schedules.length > 0 && viewMethod === 'list'"
    }],
    staticClass: "med-schedule-wrapper"
  }, [_c('div', {
    staticClass: "med-select",
    staticStyle: {
      "height": "100%"
    }
  }, _vm._l((_vm.schedules), function(item, index) {
    return _c('div', {
      staticClass: "med-button",
      class: {
        'selected-med-button': item.selected, 'unselectable': item.amountInSystem === 0
      },
      on: {
        "click": function($event) {
          return _vm.selectMed(index)
        }
      }
    }, [_c('div', {
      attrs: {
        "id": "med_desc"
      }
    }, [_c('h6', [_vm._v(_vm._s(item.medication.code) + " - " + _vm._s(item.medication.CGMH_number))]), _c('h6', [_vm._v(_vm._s(item.medication.generic_name))])]), _c('div', [_c('div', {
      attrs: {
        "id": "amount"
      }
    }, [_c('span', [_vm._v("取藥數量")]), _c('span', [_vm._v(_vm._s(item.amount))])]), _c('div', {
      attrs: {
        "id": "date"
      }
    }, [_c('span', [_vm._v("取藥日期")]), _c('span', [_vm._v(_vm._s(item.fetch_date))])]), _c('div', {
      attrs: {
        "id": "patient"
      }
    }, [_c('span', [_vm._v("病歷號")]), _c('span', [_vm._v(_vm._s(item.patient.med_record_number))])]), _c('div', {
      attrs: {
        "id": "remain_amount"
      }
    }, [_c('span', [_vm._v("系統存量")]), _c('span', [_vm._v(_vm._s(item.amountInSystem))])])])])
  }), 0)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stage === 'selectDrug' && _vm.schedules.length > 0 && _vm.viewMethod === 'drugCategory'),
      expression: "stage === 'selectDrug' && schedules.length > 0 && viewMethod === 'drugCategory'"
    }],
    staticClass: "drug-list-wrapper"
  }, _vm._l((_vm.schedulesByDrug), function(drug) {
    return _c('div', {
      staticClass: "drug-list-item",
      class: {
        'selected-med-button': drug.selected, 'unselectable': drug.amountInSystem === 0
      },
      on: {
        "click": function($event) {
          return _vm.selectScheduleByDrug(drug)
        }
      }
    }, [_c('div', {
      staticClass: "fixed-icon"
    }, [_c('font-awesome-layers', {
      staticClass: "fa-lg fa-fw"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": _vm.faCircle,
        "size": "lg",
        "color": "red"
      }
    }), _c('font-awesome-icon', {
      attrs: {
        "icon": _vm.faPills,
        "transform": "shrink-6 right-2",
        "color": "white"
      }
    })], 1)], 1), _c('div', [_c('p', [_vm._v(_vm._s(drug.medication.CGMH_number) + " - " + _vm._s(drug.medication.code))]), _c('p', [_c('small', [_vm._v(_vm._s(drug.medication.generic_name))])])]), _c('div', [_c('p', [_c('small', [_vm._v("藥物庫存量: " + _vm._s(drug.amountInSystem) + " / 藥單張數: " + _vm._s(drug.listSet.length))])])])])
  }), 0), (_vm.stage === 'selectDrug' && _vm.schedules.length === 0) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h3', [_vm._v("無取藥資料")])]) : _vm._e(), (_vm.stage === 'startFlow') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress,
      "schedules": _vm.schedules,
      "summarySelectedMed": _vm.summarySelectedMed
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面",
      "clickable": _vm.currentApp.cancel
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-4",
      "title": "列表模式"
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewMethod = 'list'
      }
    },
    slot: "button-4"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "藥物模式"
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewMethod = 'drugCategory'
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "選擇全部"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "取消全選"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deselectAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始取藥",
      "clickable": Object.values(_vm.summarySelectedMed).length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14de0bba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FetchDrugSchedule.vue
// module id = 1399
// module chunks = 1